import type { FilterState } from './types';

export const FILTER_VALUE_DELIMITER = ',';

export const DEFAULT_FILTERS: FilterState = {
  activityTypes: [],
  appointmentTypeIds: [],
  sourceTypes: [],
  statusTypes: [],
  startDate: '',
  endDate: '',
};
